var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.976 36.499 10.172 6.138c1.863 1.125 4.143-.538 3.653-2.641l-2.697-11.543 8.997-7.777c1.642-1.419.76-4.109-1.398-4.28l-11.84-1.003-4.632-10.907c-.834-1.981-3.677-1.981-4.51 0l-4.634 10.883-11.84 1.002c-2.156.172-3.039 2.862-1.397 4.28l8.997 7.777-2.697 11.544c-.49 2.103 1.79 3.766 3.653 2.64L23.976 36.5z",
    fill: "#A760B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star_full.2c3ac1a1fd56486ab2504a4e3679eed1.svg";
export { ForwardRef as ReactComponent };